import React from 'react';

export default function UrlListSummaryHeader(props) {
    const { completedUrlCount, maliciousUrlCount, totalUrlCount } = props;
    const awaitingScanPostfix = totalUrlCount == 1 ? "url has been scanned." : "urls have been scanned."
    const maliciousUrlPostfix = completedUrlCount == 1 ? "scanned url is malicious." : "scanned urls are malicious."
    return (
        <>
            <div>
                <span className="font-weight-bold">{completedUrlCount} of {totalUrlCount}</span> {awaitingScanPostfix}
            </div>
            <div>
                <span className="is_malicious font-weight-bold">{maliciousUrlCount} of {completedUrlCount}</span> {maliciousUrlPostfix}
            </div>
        </>
    );
}
